import { render, staticRenderFns } from "./DialogConfirmaRemocao.vue?vue&type=template&id=3ca12816&scoped=true"
import script from "./DialogConfirmaRemocao.vue?vue&type=script&lang=js"
export * from "./DialogConfirmaRemocao.vue?vue&type=script&lang=js"
import style0 from "./DialogConfirmaRemocao.vue?vue&type=style&index=0&id=3ca12816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca12816",
  null
  
)

export default component.exports